import { create } from "zustand";

export interface ITrxList {
	address: string;
	user_name: string;
	coins: number;
	trx: number;
	wallet_type: string;
}

export interface IEthList {
	address: string;
	user_name: string;
	coins: number;
	eth: number;
	wallet_type: string;
}

interface IParams {
	ethereumList: IEthList[];
	tronList: ITrxList[];
}

interface InitState extends IParams {
	ListUpdate: (key: keyof IParams, value: ITrxList[] | IEthList[]) => void;
}

export const usePaymentsStore = create<InitState>((set) => ({
	ethereumList: [],
	tronList: [],
	ListUpdate: (key, value) => {
		set({ [key]: [...value] });
	},
}));
